import React, {useReducer} from 'react';
import {
  ANTIMATTER_TRANSACTION_LIST,
  HANDLE_POPUP_LIST,
  CLEAR_ANTIMATTER_TRANSACTION_LIST,
} from './const';

const mainContext = React.createContext();

const reducer = (state, action) => {
  switch (action.type) {
    case ANTIMATTER_TRANSACTION_LIST:
      let lastTxs = state.transactions
      if (action.transaction.receipt) {
        const index = lastTxs.findIndex(item => {
          return item.hash === action.transaction.hash
        })
        if (index !== -1) {
          lastTxs[index] = action.transaction
        }
      } else {
        lastTxs = [action.transaction].concat(lastTxs)
      }
      window.localStorage.setItem(ANTIMATTER_TRANSACTION_LIST, JSON.stringify(lastTxs))
      return {...state, transactions: lastTxs}

    case CLEAR_ANTIMATTER_TRANSACTION_LIST:
      return {...state, transactions: []}

    case HANDLE_POPUP_LIST:
      let popups = state.popupList
      const popup = action.popup
      if (action.auction === 'add') {
        popups = [popup].concat(popups)
      } else {
        popups = popups.filter(item => {
          return item.key !== popup.key
        })
      }
      popups = popups.filter(function (item, index, arr) {
        return arr.findIndex(popup => item.key === popup.key) === index;
      });
      return {...state, popupList: popups};
    default:
      return state;
  }
};

const ContextProvider = (props) => {
  const transactionsData = window.localStorage.getItem(ANTIMATTER_TRANSACTION_LIST)
  const [state, dispatch] = useReducer(reducer, {
    transactions: transactionsData ? JSON.parse(transactionsData) : [],
    popupList: []
  });
  return (
      <mainContext.Provider value={{state, dispatch}}>
        {props.children}
      </mainContext.Provider>
  );
};

export {reducer, mainContext, ContextProvider};
